export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between animate-rise">
    <div>
      <h1 className="font-heading text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl" data-testid="page-title">
        {title}
      </h1>
      {subtitle && <p className="mt-1.5 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Panel = ({ title, action, children, className = "", testId }) => (
  <section data-testid={testId} className={`rounded-xl border border-slate-200 bg-white ${className}`}>
    {title && (
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 px-5 py-3.5">
        <h3 className="font-heading text-sm font-semibold text-slate-800">{title}</h3>
        {action}
      </div>
    )}
    {children}
  </section>
);

export const Empty = ({ text }) => <div className="px-5 py-12 text-center text-sm text-slate-400">{text}</div>;
